import { useCommonActionFromDALV2 } from '@shares/actionFormDALV2';
import { CommonNotificationSaveError, CommonNotificationSaveSuccessFully } from '@shares/CommonNotification';
import { get } from 'lodash';
import { useAsyncFn } from 'react-use';
import UpdateSugesstionSegment from './api';
import { TDtoGetSugesstionSegment } from './type';
import { SegmentSuggestion, TSegmentSuggestDetail } from '../../types';

export type TPayloadUpdateSuggestionSegment = TDtoGetSugesstionSegment & TSegmentSuggestDetail;

export type TUseUpdateSugesstionSegment = {
  isLoading?: boolean;
  response?: SegmentSuggestion;
  handleUpdateSugesstionSegment: (payload: TPayloadUpdateSuggestionSegment) => Promise<SegmentSuggestion | undefined>;
};

const useUpdateSugesstionSegment = (): TUseUpdateSugesstionSegment => {
  const commonActionFromDALV2 = useCommonActionFromDALV2();

  const [state, doFetch] = useAsyncFn(async (payload: TPayloadUpdateSuggestionSegment) => {
    const response: Promise<SegmentSuggestion | undefined> = await commonActionFromDALV2(
      UpdateSugesstionSegment,
      payload
    );
    const result = await response;
    if (result?.success) CommonNotificationSaveSuccessFully();
    else CommonNotificationSaveError(get(result, 'message', 'Somethings Went Wrong!'));
    return result;
  }, []);

  return {
    response: state?.value,
    handleUpdateSugesstionSegment: doFetch,
    isLoading: state.loading,
  };
};

export default useUpdateSugesstionSegment;
